
    import { Radio } from '@alifd/next';
    import type { RadioProps } from '@alifd/next/types/radio';
    import wrapper from './next-wrapper';

    export type BLProFormRadioProps =RadioProps;

    const BLProFormRadio = wrapper<BLProFormRadioProps>(Radio, 'BLProFormRadio');

    export default BLProFormRadio;
